import spiderman from '@/spiderman/index';

async function get(member, queryForm) {
  return (
    await spiderman.axios.get(spiderman.api.hibaby, {
      headers: {
        jwt: member.jwt,
      },
      params: queryForm,
    })
  ).data;
}

export default {
  get,
};
